var _defs, _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleNeutral2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "multiple-neutral-2_svg__Regular",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".multiple-neutral-2_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "multiple-neutral-2_svg__cls-1",
    cx: 7.5,
    cy: 7.875,
    r: 4.125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "multiple-neutral-2_svg__cls-1",
    d: "M.75 20.25a6.75 6.75 0 0113.5 0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "multiple-neutral-2_svg__cls-1",
    cx: 17.727,
    cy: 10.125,
    r: 3.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "multiple-neutral-2_svg__cls-1",
    d: "M15.813 15.068a5.526 5.526 0 017.437 5.182"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iUmVndWxhciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDoxLjVweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPm11bHRpcGxlLW5ldXRyYWwtMjwvdGl0bGU+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSI3LjUiIGN5PSI3Ljg3NSIgcj0iNC4xMjUiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0uNzUsMjAuMjVhNi43NSw2Ljc1LDAsMCwxLDEzLjUsMCIvPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMTcuNzI3IiBjeT0iMTAuMTI1IiByPSIzLjM3NSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE1LjgxMywxNS4wNjhBNS41MjYsNS41MjYsMCwwLDEsMjMuMjUsMjAuMjUiLz48L3N2Zz4=";
export { SvgMultipleNeutral2 as ReactComponent };